import { render, staticRenderFns } from "./VIcon.vue?vue&type=template&id=71f5d3d4&scoped=true&"
import script from "./VIcon.vue?vue&type=script&lang=js&"
export * from "./VIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f5d3d4",
  null
  
)

export default component.exports